import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './PlainInput.css';

const PlainInput = ({ name, id, className, ...other }) => (<input
    aria-labelledby={`label-${id || name}`}
    id={id || name}
    className={cx(styles.input, className)}
    {...other}
/>);

PlainInput.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
};

export default PlainInput;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/PlainInput/PlainInput.js